import { MathComponent } from 'mathjax-react';

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export const checkValidity = (value, type, rules) => {
    let isValid = true;
    if (!rules) {
        return true;
    }

    if (rules.required) {
        if (type !== 'checkbox') {
            isValid = value.trim() !== '' && isValid;
        } else {
            isValid = value && isValid;
        }
    }

    if (rules.minLength) {
        isValid = value.length >= rules.minLength && isValid
    }

    if (rules.maxLength) {
        isValid = value.length <= rules.maxLength && isValid
    }

    if (rules.isEmail) {
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        isValid = pattern.test(value) && isValid
    }

    if (rules.isDate) {
        const pattern = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        isValid = pattern.test(value) && isValid
    }

    if (rules.isNumeric) {
        const pattern = /^\d+$/;
        isValid = pattern.test(value) && isValid
    }

    if (rules.isChecked) {
        isValid = value && isValid
    }

    return isValid;
}

export const generateKeyVal = prefix => {
    return prefix + Math.floor(Math.random() * 1000000000000000);
}

export const generatePassword = n => {
    const hash = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let pass = '';
    let ind = 1;
    while (ind <= n) {
        const pos = Math.floor(Math.random() * 61)
        pass += hash[pos];
        ind++;
    }
    return pass;
}

export const latexParser = S => {
    let result = [];
    let i = 0;
    let str = '';
    while (i < S.length) {
        if (S.substring(i,i+1) === '$') {
            result.push(<span key={generateKeyVal('math')}>{str}</span>)
            str = '';
            if (S.substring(i,i+2) === '$$') {
                let j = 2;
                while (S.substring(i+j, i+j+2) !== '$$') {
                    str += S[i + j];
                    j++;
                }
                const absText = String.raw`${str}`;
                result.push(<MathComponent key={generateKeyVal('math')} tex={absText} display={true} />);
                str = '';
                i += j + 2;
            } else {
                let j = 1;
                str = '';
                while (S[i + j] !== '$') {
                    str += S[i + j];
                    j++;
                }
                const absText = String.raw`${str}`;
                result.push(<MathComponent key={generateKeyVal('math')} tex={absText} display={false} />);
                str = '';
                i += j + 1;
            }
        } else if (S[i] === '\\' && S[i+1] === '\\') {
            result.push(<span key={generateKeyVal('math')}>{str}</span>);
            result.push(<br key={generateKeyVal('math')}/>);
            str = '';
            i += 2;
        } else if (S.substring(i,i+3) === '<i>') {
            result.push(<span key={generateKeyVal('math')}>{str}</span>);
            str = '';
            let j =3;
            while (S.substring(i+j, i+j+4) !== '</i>') {
                str += S[i+j];
                j++;
            }
            result.push(<i key={generateKeyVal('math')}>{str}</i>);
            str = '';
            i += j+4;
        } else if (S.substring(i,i+3) === '<b>') {
            result.push(<span key={generateKeyVal('math')}>{str}</span>);
            str = '';
            let j =3;
            while (S.substring(i+j, i+j+4) !== '</b>') {
                str += S[i+j];
                j++;
            }
            result.push(<b key={generateKeyVal('math')}>{str}</b>);
            str = '';
            i += j+4;
        } else {
            str += S[i];
            i++;
        }
    }
    if (str.length > 0) {
        result.push(<span key={generateKeyVal('math')}>{str}</span>)
    }

    return result;
}